import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Grid, Collapse } from "@mui/material";
import CreateEditDialog from "../../../common/dialog/create-edit-dialog";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ManagerKitchenCheckListView from "../managerSubTasksList/manager-kitchen-checklist-view";
import ManagerFridgeTempCheckView from "../managerSubTasksList/manager-fridge-temp-check-view";
import ManagerWaterTempCheckView from "../managerSubTasksList/manager-water-temp-check-view";
import ManagerBedroomCheckView from "../managerSubTasksList/manager-bedroom-check-view";
import ManagerKeyHandlingCheckView from "../managerSubTasksList/manager-key-handling-check-view";
import ManagerVehicleCheckView from "../managerSubTasksList/manager-vehicle-check-view";
import ManagerFirstAidCheckListView from "../managerSubTasksList/manager-firstaid-checklist-view";
import ManagerAuditCheckView from "../managerSubTasksList/manager-audit-check-view";
import ManagerProductCheckView from "../managerSubTasksList/manager-product-check-view";
import ManagerActivityPlannerCheckView from "../managerSubTasksList/manager-activity-check-view";
import ManagerPocketMoneyCheckView from "../managerSubTasksList/manager-pocket-money-check-view";
import ManagerShowerCheckView from "../managerSubTasksList/manager-shower-check-view";

const ManagerTaskCard = ({ tasks, onTaskClick }) => {
  const [selectedTask, setSelectedTask] = useState(null);
  const [expandedTask, setExpandedTask] = useState(null);
  const [dialogType, setDialogType] = useState(null);
  const [checkDialogOpen, setCheckDialogOpen] = useState(false);

  const handleToggleExpand = (index) => {
    setExpandedTask(expandedTask === index ? null : index);
  };

  const dialogComponents = {
    kitchen: ManagerKitchenCheckListView,
    fridge: ManagerFridgeTempCheckView,
    water: ManagerWaterTempCheckView,
    bedroom: ManagerBedroomCheckView,
    sign: ManagerKeyHandlingCheckView,
    vehicle: ManagerVehicleCheckView,
    aid: ManagerFirstAidCheckListView,
    audit: ManagerAuditCheckView,
    product: ManagerProductCheckView,
    activity: ManagerActivityPlannerCheckView,
    pocket: ManagerPocketMoneyCheckView,
    shower: ManagerShowerCheckView,
  };

  const SelectedComponent = dialogComponents[dialogType] || null;

  return (
    <Box sx={{ mb: 4 }}>
      {tasks.map((task, index) => {
        return (
          <Card
            sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
            onClick={() => {
              onTaskClick(task); // Trigger the task click handler
              handleToggleExpand(index); // Toggle expansion for the task

              if (!checkDialogOpen && task?.checklist?.length === 0 && task.taskType === "default") {
                const dialogMapping = {
                  kitchen: "kitchen",
                  fridge: "fridge",
                  water: "water",
                  bedroom: "bedroom",
                  sign: "sign",
                  vehicle: "vehicle",
                  aid: "aid",
                  audit: "audit",
                  product: "product",
                  activity: "activity",
                  pocket: "pocket",
                  shower: "shower",
                };

                const taskNameLower = task.taskName.toLowerCase();
                const matchedType = Object.keys(dialogMapping).find((key) => taskNameLower.includes(key));

                if (matchedType) {
                  setDialogType(dialogMapping[matchedType]);
                  setCheckDialogOpen(true);
                  setSelectedTask(task);
                } else {
                  setDialogType(null);
                  setCheckDialogOpen(false);
                }
              }
            }}
          >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item lg={9} md={9} xs={12}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item>
                      <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                        <FiberManualRecordIcon color='info' sx={{ fontSize: 10, mr: 1 }} />
                        {task.taskName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography sx={{ fontSize: "12px", color: "black" }}>{task.description}</Typography>
                </Grid>
              </Grid>
              {/* Collapse Section */}
              <Collapse in={expandedTask === index}>
                <Box mt={2}>
                  {(task.checklist || []) // Ensure checklist is an array
                    .filter((item) => item && item?.item) // Filter out invalid items
                    .map((item, subIndex) => (
                      <Card
                        key={subIndex}
                        sx={{
                          ml: 2,
                          bgcolor: "#f9f9f9",
                          color: "#000",
                          padding: 2,
                          borderRadius: 0,
                        }}
                        onClick={(e) => e.stopPropagation()} // Prevent collapse toggle on subtask click
                      >
                        <Grid container justifyContent='space-between'>
                          <Grid item>
                            <Typography sx={{ fontSize: "12px" }}>{item?.item}</Typography>
                          </Grid>
                          <Grid item>
                            <Typography sx={{ fontSize: "12px" }}>
                              {item?.status === "true" ? "Completed" : "Still not completed"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Card>
                    ))}
                </Box>
              </Collapse>
            </CardContent>
            <CreateEditDialog isOpen={checkDialogOpen} maxWidth='xl' onClose={() => setCheckDialogOpen(false)}>
              {SelectedComponent && (
                <SelectedComponent onClose={() => setCheckDialogOpen(false)} selectedMainTask={selectedTask} />
              )}
            </CreateEditDialog>
            ;
          </Card>
        );
      })}
    </Box>
  );
};

export default ManagerTaskCard;
